import React from 'react';

function OnboardingOverlay({ onClose }) {
  return (
    <div className="overlay">
      <div className="overlay-content">
        <h2>Welcome to Sweet Draw!</h2>
        <div className="instructions">
          <p>
            Sweet Draw is a digital companion for the Candyland board game. Shuffle, draw, and track cards with ease—no physical deck needed!
          </p>
          <p>🃏 <strong>How to Use:</strong></p>
          <ul>
            <li>Tap <strong>Draw</strong> to pick a card.</li>
            <li>See the current card at the top.</li>
            <li>View recent cards below.</li>
            <li>Tap <strong>Shuffle</strong> to reset the deck.</li>
          </ul>
        </div>
        <button className="overlay-button" onClick={onClose}>
          Got it!
        </button>
      </div>
    </div>
  );
}

export default OnboardingOverlay;